import React, { Component, Fragment } from "react";
import { Button } from "react-bootstrap";
import { contactEmail } from "../../../constants";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Fragment>
          <div className="error-boundary-container">
            <h3>
              Ooops! The action you would like to perform might have some issue
              please report so that we can fix it.
            </h3>
            <a href={"mailto: " + contactEmail}>
              <Button color="danger-gradien" size="lg">
                Contact us
              </Button>
            </a>
          </div>
        </Fragment>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
